import axios from 'axios'
import constants from '../lib/constants'
import _ from 'lodash'

// CONSTANTS
export const GET_PRESCRIBER = 'GET_PRESCRIBER'
export const GET_PRESCRIBER_COMPLETE = 'GET_PRESCRIBER_COMPLETE'
export const GET_PRESCRIBERS = 'GET_PRESCRIBERS'
export const GET_PRESCRIBERS_COMPLETE = 'GET_PRESCRIBERS_COMPLETE'
export const CREATE_PRESCRIBER = 'CREATE_PRESCRIBER'
export const CREATE_PRESCRIBER_COMPLETE = 'CREATE_PRESCRIBER_COMPLETE'
export const ADD_PRESCRIBER_TO_SITE = 'ADD_PRESCRIBER_TO_SITE'
export const ADD_PRESCRIBER_TO_SITE_COMPLETE = 'ADD_PRESCRIBER_TO_SITE_COMPLETE'
export const UPLOAD_SIGNATURE = 'UPLOAD_SIGNATURE'
export const UPLOAD_SIGNATURE_COMPLETE = 'UPLOAD_SIGNATURE_COMPLETE'
export const UPDATE_PRESCRIBER = 'UPDATE_PRESCRIBER'
export const UPDATE_PRESCRIBER_COMPLETE = 'UPDATE_PRESCRIBER_COMPLETE'
export const GET_PRESCRIBER_SALES = 'GET_PRESCRIBERS_SALES'
export const GET_PRESCRIBER_SALES_COMPLETE = 'GET_PRESCRIBER_SALES_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getPrescriber = (prescriberId, includePublicSignatureUrl = false) => {
  return (dispatch, getState) => {
    const url = `${constants.API_URL}/prescribers/${prescriberId}/?include_public_signature_url=${includePublicSignatureUrl}`
    dispatch({ type: GET_PRESCRIBER })
    return axios.get(url)
    .then((response) => {
      let prescriber = response.data
      prescriber.name = `${prescriber.first_name} ${prescriber.last_name}`
      dispatch({
        type: GET_PRESCRIBER_COMPLETE,
        payload: {
          prescriber: prescriber
        }
      })
      return response
    })
  }
}

export const getPrescribers = (salesPersonId = null, siteId = null, includePublicSignatureUrl = false) => {
  return (dispatch, getState) => {
    let url = `${constants.API_URL}/prescribers/list?`
    if (salesPersonId !== null) {
      url += `sales_person_id=${salesPersonId}&`
    }
    if (siteId !== null) {
      url += `site_id=${siteId}&`
    }
    if (includePublicSignatureUrl !== null) {
      url += `include_public_signature_url=${includePublicSignatureUrl}`
    }
    dispatch({ type: GET_PRESCRIBERS })
    return axios.get(url)
    .then((response) => {
      const sortedPrescribers = response.data.prescribers.sort((a, b) =>
        ((a.first_name + a.last_name) > (b.first_name + b.last_name) ? 1 : -1))

      const sortedPrescribersWithNames = _.map(sortedPrescribers, (prescriber) => {
        prescriber.name = `${prescriber.first_name} ${prescriber.last_name}`
        return prescriber
      })
      dispatch({
        type    : GET_PRESCRIBERS_COMPLETE,
        payload : {
          prescribers: sortedPrescribersWithNames,
        }
      })
      return response
    })
  }
}

export const createPrescriber = (firstName, lastName, email, address, phoneNumber, npi, siteIDs, signatureFile = null) => {
  return (dispatch) => {
    dispatch({ type: CREATE_PRESCRIBER })
    return axios.post(`${constants.API_URL}/prescribers/create`,
      {
        first_name: firstName,
        last_name: lastName,
        email,
        npi,
        phone_number: phoneNumber,
        address,
        site_ids: siteIDs,
      }
    )
    .then((response) => {
      const newPrescriber = response.data
      newPrescriber.name = `${newPrescriber.first_name} ${newPrescriber.last_name}`
      dispatch({
        type    : CREATE_PRESCRIBER_COMPLETE,
        payload : {
          createdPrescriber: newPrescriber
        }
      })
      if (signatureFile) {
        dispatch(uploadSignature(newPrescriber.id, signatureFile))
      }
    })
  }
}

export const uploadSignature = (prescriberId, signatureFile) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_SIGNATURE })
    let formData = new FormData()
    formData.append('signature', signatureFile)
    return axios.post(`${constants.API_URL}/prescribers/${prescriberId}/upload_signature`,
      formData,
      { headers: { 'content-type': 'multipart/form-data' } }
    )
    .then((response) => {
      dispatch({
        type    : UPLOAD_SIGNATURE_COMPLETE,
        payload : {
          uploadedSignature: true
        }
      })
    })
    .catch((error) => {
      dispatch({
        type    : UPLOAD_SIGNATURE_COMPLETE,
        payload : {
          uploadedSignature: false
        }
      })
    })
  }
}

// this is just a POST, to be used within this file, not an action
const updatePrescriber = (prescriberId, data) => {
  return axios.post(`${constants.API_URL}/prescribers/${prescriberId}/update`,
    {
      ...data
    }
  )
}

// this is an exported action that can be dispatched and will update redux store
export const updatePrescriberAndUploadSignature = (prescriberId, data, signatureFile = null) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PRESCRIBER })
    return axios.post(`${constants.API_URL}/prescribers/${prescriberId}/update`,
      {
        ...data,
      }
    ).then((response) => {
      const updatedPrescriber = response.data
      updatedPrescriber.name = `${updatedPrescriber.first_name} ${updatedPrescriber.last_name}`
      dispatch({
        type    : UPDATE_PRESCRIBER_COMPLETE,
        payload : {
          ...updatedPrescriber
        }
      })
      if (signatureFile) {
        return dispatch(uploadSignature(updatedPrescriber.id, signatureFile))
      }
      return Promise.resolve()
    })
    .then(() => {
      return dispatch(getPrescriber(prescriberId, true))
    })
  }
}

export const updateSalesPerson = (prescriberId, salesPersonId) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PRESCRIBER })
    return updatePrescriber(prescriberId, { sales_person_id: salesPersonId })
    .then((response) => {
      dispatch({
        type: UPDATE_PRESCRIBER_COMPLETE,
        payload: response.data
      })
      return response
    })
  }
}

export const addPrescriberToSite = (prescriberId, siteId) => {
  return (dispatch) => {
    dispatch({ type: ADD_PRESCRIBER_TO_SITE })
    return updatePrescriber(prescriberId, { site_ids: [siteId] })
    .then((response) => {
      const updatedPrescriber = response.data
      updatedPrescriber.name = `${updatedPrescriber.first_name} ${updatedPrescriber.last_name}`
      dispatch({
        type    : ADD_PRESCRIBER_TO_SITE_COMPLETE,
        payload : {
          updatedPrescriber
        }
      })
    })
  }
}

export const getPrescriberSales = () => {
  return (dispatch) => {
    dispatch({ type: GET_PRESCRIBER_SALES })
    return axios.get(`${constants.API_URL}/prescribers/rems_sales`)
    .then((response) => {
      return dispatch({
        type: GET_PRESCRIBER_SALES_COMPLETE,
        payload: response.data
      })
    })
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_PRESCRIBER_COMPLETE] : (state, action) => {
    const { prescriber } = action.payload
    const matchingPrescriberIndex = _.findIndex(state.prescribers, (p) => p.id === prescriber.id)
    if (matchingPrescriberIndex > -1) {
      state.prescribers[matchingPrescriberIndex] = prescriber
    }
    const newState = {
      ...state,
    }
    return newState
  },
  [GET_PRESCRIBERS_COMPLETE] : (state, action) => {
    const { prescribers } = action.payload
    const newState = {
      ...state,
      prescribers
    }
    return newState
  },
  [CREATE_PRESCRIBER_COMPLETE] : (state, action) => {
    const { createdPrescriber } = action.payload
    const newState = {
      ...state,
      createdPrescriber
    }
    return newState
  },
  [ADD_PRESCRIBER_TO_SITE_COMPLETE] : (state, action) => {
    const { updatedPrescriber } = action.payload
    const newState = {
      ...state,
      updatedPrescriber
    }
    return newState
  },
  [UPLOAD_SIGNATURE_COMPLETE] : (state, action) => {
    const { uploadedSignature } = action.payload
    const newState = {
      ...state,
      uploadedSignature
    }
    return newState
  },
  [GET_PRESCRIBER_SALES_COMPLETE] : (state, action) => {
    return {
      ...state,
      remsPrescribers: action.payload
    }
  },
  [UPDATE_PRESCRIBER_COMPLETE]: (state, action) => {
    const updatedPrescriber = action.payload
    const matchingPrescriberIndex = _.findIndex(state.prescribers, (p) => p.id === updatedPrescriber.id)
    if (matchingPrescriberIndex > -1) {
      state.prescribers[matchingPrescriberIndex] = updatedPrescriber
    }
    return {
      ...state,
      updatedPrescriber,
    }
  }
}

// REDUCER

const initialState = {
  prescribers: [],
  remsPrescribers: {},
  createdPrescriber: null,
  updatedPrescriber: null,
  uploadedSignature: false,
}

export default function prescribersReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/prescribers.js